import { render } from "./_form-content-intro.vue?vue&type=template&id=1a56d964&lang=pug"
import script from "./_form-content-intro.vue?vue&type=script&lang=js"
export * from "./_form-content-intro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__